import Service, { service } from '@ember/service';

export default class ClientInsuranceAccessService extends Service {
  @service currentPractice;

  get claimAssistantOrManagedBilling() {
    const claimAssistantSettingActive = this.currentPractice.get('claimAssistantSettingActive');
    const featureThirdPartyBilling = this.currentPractice.get('featureThirdPartyBilling');

    return (
      claimAssistantSettingActive ||
      ['live', 'onboarding', 'offboarding'].includes(featureThirdPartyBilling)
    );
  }
}
